import { render } from "./LoginUpload.vue?vue&type=template&id=62029bd4"
import script from "./LoginUpload.vue?vue&type=script&lang=js"
export * from "./LoginUpload.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__